<template lang="pug">
  .form-group
    .checkbox.checkbox-rich.bcard-user-details-settings-chk
      label
        input(type="checkbox" :name="field", value="1", v-model="checked", @change="onChange")
        span: i.fa.fa-check.fa-lg
    label {{ fieldName }}
      span(v-if="requiredMark").bcard-required (*)
    slot(name="dispArea", :value="value", :dispValue="dispValue")
      template(v-if="value")
        input.form-control(type="text" :value="dispValue")
      template(v-else)
        .form-control-static {{ dispValue || app_lang.NO_INPUT }}

</template>

<script>

export default {
  name: 'UserSettingCheckboxItem',
  props: {
    value: {type: Boolean, default: false},
    field: {type: String, default: ''},
    fieldName: {type: String, default: ''},
    requiredMark: {type: Boolean, default: false},
    dispValue: {type: String, default: ''}
  },
  data: function () {
    return {
      checked: this.value
    }
  },
  watch: {
    value: function (to, from) {
      this.checked = to
    }
  },
  methods: {
    onChange: function () {
      this.$emit('input', this.checked)
    }
  }
}
</script>

<style lang="scss" scoped>
.bcard-user-details-settings-chk {
  position: absolute;
  margin-top: 0;
  margin-left: -41px;
  z-index: 1;
}

.bcard-user-details-setting {
  // OFF時の表示
  .bcard-user-details-settings-chk:not(.checked) {
    & ~ .form-control {
      display: none;
    }
  }
  // ON時の表示
  .bcard-user-details-settings-chk.checked {
    & ~ .form-control-static {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/_UserSetting_checkbox-item.vue